<template>
  <PageModel pageName="通知" pageType="notice"/>
</template>

<script>
  import PageModel from './homePageManage.vue'
  import { ConvertDate } from "../../utils/date";
  import { decode, encode } from "../../store/modules/myUtil";
  import store from '../../store/index'

  export default {
    name: "noticeManage",
    components:{
      PageModel
    },
    data(){
      return{}
    }
  }
</script>

<style scoped>

</style>
